// @flow

import styled, { css } from 'styled-components';
import { media, zIndexMap } from '../../../helpers';
import type { Props } from '../types';
import type { Theme } from '../../../types';

export default styled<any, Theme, Props>('div')`
  background: #fff;
  bottom: 0;
  max-width: 100%;
  overflow-y: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: ${zIndexMap.cartColumn};
  transition:
    left .3s ease .1s,
    right .3s ease .1s;

  ${props => props.open && !props.overlay && css`
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
  `}

  ${media.sm(css`
    width: 20rem;
  `)}

  ${media.lg(css`
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
    display: block;
  `)}

  ${props => props.position === 'left' && css`
    right: 100%;
    ${props.open && css`
      right: 0;
      ${media.sm(css`
        right: calc(100% - 20rem);
      `)}
    `}
  `}

  ${props => props.position === 'right' && css`
    left: 100%;
    ${props.open && css`
      left: 0;
      ${media.sm(css`
        left: calc(100% - 20rem);
      `)}
    `}
  `}

  ${media.lg(css`
    align-self: flex-start;
    background: transparent;
    box-shadow: none;
    box-sizing: border-box;
    left: 0;
    overflow-y: none;
    padding: 0 0.5rem;
    position: relative;
    ${props => props.sticky && css`
      position: sticky;
      top: calc(4.4375rem * 2);
    `}
    ${props => props.width && css`
      width: ${props.width * 100}%;
    `}
    z-index: 1;
  `)}
`;
